{
    "actions": {
        "row": {
            "subscription": "Subscription actions",
            "activate": "Activation",
            "terminal": "POS Terminal actions",
            "terminate": "Immediate termination",
            "scheduled_terminate": "Scheduled termination",
            "migrate": "Migration",
            "update_plan": "Update plan",
            "update_organization": "Update organization",
            "add_envelope": "Create envelope",
            "historics_access": "POS terminal history"
        }
    },
    "filter": {
        "placeholder": {
            "last_source_ip": "Filter by IP",
            "sim_card_number": "Filter by SIM",
            "client": {
                "legal_name": "Filter by organization",
                "code": "Filter by client code"
            },
            "plan_label": "Filter by plan label",
            "product_code": "Filter by plan product code"
        }
    },
    "keys": {
        "last_source_ip": "IP",
        "last_ssl_version": "Certificate",
        "last_connection": "Connected on",
        "status": "Gateway subscr.",
        "sim_card_number": "SIM",
        "client": {
            "legal_name": "Organization",
            "code": "Client code"
        },
        "plan_label": "Plan label",
        "product_code": "Plan product code",
        "created_at": "Added on",
        "activation_date": "Activated on",
        "resiliation_date": "Cancellation",
        "start_billing_date": "Billing",
        "updated_at": "Updated at",
        "last_iccid_operator": "SIM operator",
        "active_iccid_operator": "SIM operator",
        "start_blacklist": "Blocked on"
    },
    "modal": {
        "terminate": {
            "title": "Terminate subscription",
            "text": "Do you want to terminate the subscription for this POS terminal?",
            "success": "Subscription successfully terminated",
            "error": "An error occurred when terminating the subscription",
            "scheduled": {
                "text": "Scheduled termination of subscription",
                "summary": "The subscription will be terminated on {{date}}",
                "success": "The subscription is now scheduled to be terminated on {{date}}",
                "error": "An error occurred and termination could not be programmed."
            }
        },
        "activate": {
            "title": "Activate subscription",
            "text": "You have selected the \"{{planLabel}}\" plan to activate this subscription.",
            "confirm": "Would you like to continue?",
            "success": "The subscription has been successfully activated",
            "error": "An error has occurred during subscription activation",
            "steps": {
                "select_plan": "Step {{step}} on {{maxStep}}: Select a plan to add",
                "activate": "Step {{step}} on {{maxStep}}: Subscription activation"
            }
        },
        "migrate": {
            "title": "Declaring a migration",
            "text": "You are about to declare a migration for this subscription.",
            "info": "The billing start date for this subscription will be postponed to :",
            "confirm": "Would you like to continue?",
            "success": "Billing has been successfully modified!",
            "error": "An error occurred when declaring the migration"
        },
        "add_envelope": {
            "title": "Create an envelope",
            "success": "Operation successfully accomplished !",
            "error": {
                "default": "Operation failed",
                "already_exists": "There is already an envelope programmed for this terminal. Please delete it before programming a new one."
            },
            "steps": {
                "select_download_code": "Step {{step}} of {{maxStep}}: Select donwload code",
                "confirm": "Step {{step}} of {{maxStep}}: Confirm envelope creation"
            },
            "confirmation": {
                "message": "You are about to program an envelope based on the download code {{downloadCode}} for this terminal.",
                "question": "Do you want to confirm?"
            }
        }
    },
    "status": {
        "TO_BE_ACTIVATED": "Pending",
        "ACTIVATED": "Activated",
        "TERMINATED": "Terminated",
        "IN_STOCK": "In stock"
    },
    "text": {
        "is_direct": "Direct subscription"
    },
    "tooltip": {
        "badge": {
            "migrate": "Migration in progress",
            "terminate": "A termination has been programmed for this subscription on {{resiliationDate}}",
            "restock": "This subscription is not assigned to a merchant. To activate it, you have to put it back in stock first.",
            "activate": "This subscription is not assigned to a merchant, it will after the next remote collection, authorization or remote configuration."
        },
        "date": {
            "alert": {
                "warning": "Last connection {{days}}",
                "error": "Last connection {{days}} days ago or more"
            }
        }
    }
}